<div class="d-flex flex-column align-items-center">
  <mat-spinner class="mb-3" color="accent"></mat-spinner>
  <h1 class="mb-0">{{ text }}</h1>
</div>
